export default {
  email: 'hello@dynopia.com',
  facebookPage: {
    url: 'https://www.facebook.com/dynopia/',
  },
  githubProfile: {
    url: 'https://github.com/panayi',
  },
};



// WEBPACK FOOTER //
// ./src/app/data/contact/index.js